import * as React from "react";
import { useDispatch } from "react-redux";
import { ResidentDTO } from "@inosio/payments-sdk";
import { clearPaymentStates, getResidentBalanceDetails } from "./saga/pmResidentsSlice";
import MakePaymentModal from "../../resui/payments/components/MakePaymentModal";

export enum UIContextEnum {
  pmUI = "PROPERTY_MANAGER_UI",
  resUI = "RESIDENT_UI",
}

export const defaultUIContext = React.createContext(UIContextEnum.pmUI);

export default function MakeAdhocOneTimePayment(props: { showAdhocOTPDialog: boolean; setShowAdhocOTPDialog: React.Dispatch<React.SetStateAction<boolean>>; residentsDetails: ResidentDTO }) {
  const dispatch = useDispatch();
  const { showAdhocOTPDialog, setShowAdhocOTPDialog, residentsDetails } = props;

  React.useEffect(() => {
    dispatch(clearPaymentStates({}));

    showAdhocOTPDialog &&
      residentsDetails?.Uuid &&
      dispatch({
        type: getResidentBalanceDetails.type,
        payload: {
          residentUuid: residentsDetails?.Uuid,
        },
      }); // fetch balance details
  }, [dispatch, residentsDetails?.Uuid, showAdhocOTPDialog]);

  return (
    <defaultUIContext.Provider value={UIContextEnum.pmUI}>
      {showAdhocOTPDialog && (
        <MakePaymentModal
          open={showAdhocOTPDialog}
          residentsDetails={residentsDetails}
          closeCallback={() => setShowAdhocOTPDialog(false)}
        />
      )}
    </defaultUIContext.Provider>
  );
}
